import { render } from "./FallbackPage.vue?vue&type=template&id=39cb404f&scoped=true&ts=true"
import script from "./FallbackPage.vue?vue&type=script&lang=ts"
export * from "./FallbackPage.vue?vue&type=script&lang=ts"

import "./FallbackPage.vue?vue&type=style&index=0&id=39cb404f&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cb404f"]])

export default __exports__